// extracted by mini-css-extract-plugin
module.exports = {"main-component":"deselect_main-component__bHzM3"};